import React, { useRef, useEffect } from "react";
import { X } from "lucide-react";

const Popup = (props) => {
  const popupRef = useRef(null);
  const { setTrigger } = props;

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popupRef.current && !popupRef.current.contains(event.target)) {
        setTrigger(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [setTrigger]);

  return props.trigger ? (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div className="absolute inset-0 bg-black/60"></div>
      <div
        ref={popupRef}
        className="relative z-10 max-h-[70vh] max-w-3xl overflow-auto rounded-sm border border-vscode-border bg-vscode-panel p-6 shadow-lg"
      >
        <button
          className="absolute right-2 top-2 rounded-sm p-1 text-vscode-textMuted hover:bg-vscode-listHover hover:text-vscode-textBright"
          onClick={() => props.setTrigger(false)}
          title="Close"
        >
          <X size={16} />
        </button>
        {props.children}
      </div>
    </div>
  ) : (
    ""
  );
};

export default Popup;
